import { actions } from './patient_balance/actions'
import { getters } from './patient_balance/getters'
import { state } from './patient_balance/state'
import { mutations } from './patient_balance/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
